import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from '../../components/sections/HeroSection';
import TrustBar from '../../components/sections/TrustBar';
import ServicesOverview from '../../components/sections/ServicesOverview';
import AIAnswerBlock from '../../components/sections/AIAnswerBlock';
import ProcessSection from '../../components/sections/ProcessSection';
import WhyChooseUsSection from '../../components/sections/WhyChooseUsSection';
import ServiceAreasSection from '../../components/sections/ServiceAreasSection';
import SocialProofSection from '../../components/sections/SocialProofSection';
import FAQSection from '../../components/sections/FAQSection';
import FinalCTASection from '../../components/sections/FinalCTASection';

const allServices = [
  {
    image: 'https://public.readdy.ai/ai/img_res/c833def5f526480792811a49c81e735d.jpg',
    title: 'Polished Concrete',
    description: 'Mechanically ground and honed to gloss levels 1–4 using industrial diamond tooling — durable, low-maintenance, works on new pours and existing slabs of any age.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=close%20up%20detail%20diamond%20polishing%20grinding%20machine%20working%20on%20concrete%20floor%20surface%20industrial%20setting%20sparks%20grinding%20action%20workmanship%20premium%20restoration%20professional%20photography&width=600&height=760&seq=svcsvc02&orientation=portrait',
    title: 'Concrete Restoration',
    description: 'Grind, seal, overlay, or full diamond polish. We revitalize worn and damaged concrete — including 50-year-old slabs — at a fraction of replacement cost.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=fresh%20industrial%20epoxy%20polyurea%20floor%20coating%20application%20commercial%20floor%20smooth%20seamless%20cool%20gray%20tone%20professional%20finish%20modern%20warehouse%20commercial%20space%20overhead%20bright%20lights%20clean%20premium&width=600&height=880&seq=svcsvc03&orientation=portrait',
    title: 'Floor Coatings',
    description: 'Epoxy, polyurea, and polyaspartic coatings for garages, warehouses, retail, and commercial spaces — precisely selected for your environment and performance needs.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=custom%20colorful%20decorative%20brand%20logo%20permanently%20embedded%20into%20polished%20concrete%20floor%20commercial%20retail%20showroom%20vibrant%20colors%20geometric%20design%20architectural%20feature%20high%20gloss%20premium%20photography&width=600&height=760&seq=svcsvc04&orientation=portrait',
    title: 'Custom Graphics & Logos',
    description: 'Custom logos and graphics embedded permanently into concrete. Perfect for retail showrooms, sports facilities, schools, and corporate lobbies.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=close%20up%20luxury%20terrazzo%20floor%20polished%20high%20gloss%20white%20cream%20matrix%20with%20colorful%20marble%20glass%20granite%20chip%20mosaic%20pattern%20warm%20natural%20tones%20premium%20architectural%20material%20detail%20photography&width=600&height=880&seq=svcsvc05&orientation=portrait',
    title: 'Terrazzo',
    description: 'Marble, quartz, glass, or granite chips set in cement or epoxy matrix, ground and polished to a luxurious finish. Timeless beauty with exceptional durability.',
    href: '/services',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=smooth%20cement%20topping%20overlay%20concrete%20resurfacing%20application%20trowel%20work%20residential%20interior%20clean%20fresh%20warm%20cream%20white%20surface%20modern%20home%20renovation%20professional%20workmanship%20photography&width=600&height=760&seq=svcsvc06&orientation=portrait',
    title: 'Resurfacing',
    description: 'Cement-based toppings applied over existing concrete to create a fresh, decorative surface. Ideal for aging slabs that need renewed appearance without full replacement.',
    href: '/services',
  },
];

const serviceQAs = [
  {
    question: 'What is polished concrete flooring?',
    answer: 'Polished concrete uses industrial diamond tooling to mechanically grind and hone a concrete surface to a high-gloss or matte finish. It\'s one of the most durable, low-maintenance flooring options available — suitable for both new pours and existing concrete of any age, residential or commercial.',
  },
  {
    question: 'What floor coating options are available?',
    answer: 'We offer epoxy, polyurea, and polyaspartic coatings — from garage and warehouse base systems to decorative flake and quartz broadcast finishes. We recommend the right system based on your specific environment, traffic load, and performance requirements.',
  },
  {
    question: 'Can you install custom logos in concrete floors?',
    answer: 'Yes. Polished Concrete Plus specializes in unique graphics and logo embedding — perfect for retail showrooms, sports facilities, schools, and corporate lobbies. We use durable colorfast materials that become a permanent, integral part of the polished floor surface itself.',
  },
  {
    question: 'What is terrazzo flooring?',
    answer: 'Terrazzo is a composite material — marble, quartz, glass, or granite chips set in a cement or epoxy matrix, then ground and polished smooth. It delivers exceptional durability and a luxurious, timeless appearance perfectly suited to high-end residential and commercial interiors.',
  },
];

const serviceSteps = [
  { number: '01', title: 'Site Assessment', description: 'Thorough evaluation of existing surface conditions, substrate strength, and finish requirements before any work begins.', icon: 'ri-search-eye-line' },
  { number: '02', title: 'Surface Grinding', description: 'Industrial diamond grinding removes old coatings, levels imperfections, and opens the concrete pores for proper adhesion.', icon: 'ri-settings-3-line' },
  { number: '03', title: 'System Application', description: 'Chosen system applied — polish progressions, coating layers, terrazzo matrix, or cement-based overlay installation.', icon: 'ri-paint-brush-2-line' },
  { number: '04', title: 'Detail & Edge Work', description: 'Perimeter edges, transitions, and decorative detail finished by hand with precision. No corner is overlooked.', icon: 'ri-crop-line' },
  { number: '05', title: 'Final Seal & QC', description: 'Final protective seal applied, quality control inspection performed, site cleaned, and handoff completed.', icon: 'ri-shield-check-line' },
];

const serviceReasons = [
  {
    icon: 'ri-tools-fill',
    title: 'Full-Spectrum Capabilities',
    points: [
      'Polished concrete: gloss levels 1–4 (matte to mirror)',
      'Epoxy, polyurea, and polyaspartic coating systems',
      'Terrazzo — cement and epoxy matrix systems',
      'Custom embedded graphics and permanent logo work',
    ],
  },
  {
    icon: 'ri-building-fill',
    title: 'Residential to Industrial Scale',
    points: [
      'New home builds and remodeled existing slabs',
      'Commercial showrooms, retail, and office spaces',
      'Industrial warehouses and manufacturing floors',
      '50-year-old concrete brought back to life',
    ],
  },
  {
    icon: 'ri-leaf-fill',
    title: 'Durable & Sustainable Results',
    points: [
      'Low-VOC coatings and sustainable processes',
      'Minimal long-term maintenance requirements',
      'No floor covering replacement needed',
      'Works with existing concrete — no demolition required',
    ],
  },
];

const serviceAreas = [
  { state: 'Minnesota', cities: ['Minneapolis', 'St. Paul', 'Duluth', 'Rochester', 'St. Cloud', 'Moorhead', 'Sauk Rapids', 'Rice'] },
  { state: 'Surrounding States', cities: ['Iowa', 'Wisconsin', 'North Dakota', 'South Dakota'] },
];

const serviceFAQs = [
  {
    question: 'How much does polished concrete flooring cost in Minnesota?',
    answer: 'Costs vary based on square footage, existing slab condition, and the finish level required. Polished Concrete Plus offers free on-site estimates — call 320.493.1454 to discuss your project and get accurate pricing tailored to your specific floor and finish goals without any obligation.',
  },
  {
    question: 'What is the best floor coating for a commercial garage or warehouse?',
    answer: 'For commercial garages and warehouses, we typically recommend polyurea or polyaspartic coatings — they cure faster than epoxy, resist UV yellowing, handle heavy traffic, and are often installed in a single day. We select the right system based on your specific environment.',
  },
  {
    question: 'How long does polished concrete flooring last?',
    answer: 'When properly installed and maintained, polished concrete can last the lifetime of the building — often 50 years or more. It\'s one of the most durable flooring options available, which is why it\'s chosen for hospitals, airports, and retail chains across the country.',
  },
  {
    question: 'Can you resurface cracked or damaged concrete?',
    answer: 'Yes. Concrete restoration is one of our core services. Depending on the damage level, we use crack repair, grinding, overlays, or cement-based toppings. Most worn concrete can be beautifully restored without full replacement — saving significant cost and project disruption.',
  },
  {
    question: 'Do you offer free estimates near Minneapolis or St. Paul?',
    answer: 'Absolutely. Polished Concrete Plus provides free consultations and estimates for all floor coating, polished concrete, and restoration projects in the Minneapolis-St. Paul metro area and throughout all of Minnesota. Call 320.493.1454 to schedule your free assessment today.',
  },
];

export default function ServicesPage() {
  return (
    <main>
      <Navbar />

      <HeroSection
        backgroundImage="https://readdy.ai/api/search-image?query=extreme%20close%20up%20macro%20abstract%20polished%20concrete%20floor%20surface%20ultra%20high%20gloss%20crystalline%20texture%20warm%20gold%20amber%20reflections%20dark%20background%20premium%20industrial%20luxury%20photography%20dramatic%20lighting%20depth&width=1920&height=1080&seq=svchero01&orientation=landscape"
        eyebrow="Expert Surface Finishing — Since 2003"
        headline="Complete Concrete"
        headlineAccent="Services & Solutions."
        subheadline="From polished concrete and floor coatings to terrazzo, custom graphics, and full concrete restoration — Polished Concrete Plus delivers certified craftsmanship across Minnesota and the upper Midwest."
        ctaText="Get a Free Estimate"
        ctaHref="#contact"
        secondaryCtaText="Call 320.493.1454"
        secondaryCtaHref="tel:3204931454"
      />

      <TrustBar />

      <ServicesOverview
        eyebrow="Our Services"
        headline="Every Surface. Every Application."
        subheadline="The full spectrum of concrete finishing and coating solutions for residential, commercial, and industrial projects."
        services={allServices}
        ctaLabel="Request a Free Estimate"
        ctaHref="#contact"
      />

      <AIAnswerBlock
        eyebrow="Service Details — AI & Voice Search Ready"
        headline="Exactly What Each Service Involves"
        intro="Clear, honest information about every service we provide — so you can make the right decision for your space, timeline, and budget."
        qas={serviceQAs}
      />

      <ProcessSection
        eyebrow="Our Installation Process"
        headline="Precision from Start to Finish"
        steps={serviceSteps}
      />

      <WhyChooseUsSection
        eyebrow="Why Polished Concrete Plus"
        headline="Capabilities That Set Us Apart"
        subheadline="We don't just install floors. We engineer durable, beautiful surfaces built to perform for decades across every application."
        reasons={serviceReasons}
        backgroundImage="https://readdy.ai/api/search-image?query=professional%20concrete%20polishing%20installation%20in%20large%20commercial%20space%20wide%20angle%20dramatic%20side%20lighting%20craftsman%20at%20work%20premium%20workmanship%20cinematic%20atmosphere%20industrial%20setting%20photography&width=900&height=1100&seq=svcwhy01&orientation=portrait"
      />

      <ServiceAreasSection
        eyebrow="Service Areas"
        headline="Serving the Upper Midwest"
        subheadline="Based in Sauk Rapids, MN — we travel statewide and regionally to deliver premium concrete finishing services."
        areas={serviceAreas}
        showMap
      />

      <SocialProofSection />

      <FAQSection
        eyebrow="Service FAQs"
        headline="Questions About Our Services"
        faqs={serviceFAQs}
      />

      <FinalCTASection
        headline="Let's Build Something Exceptional"
        subheadline="Tell us about your project. We'll provide a free estimate and recommend the ideal system for your space, budget, and timeline."
        backgroundImage="https://readdy.ai/api/search-image?query=elegant%20modern%20commercial%20office%20lobby%20entrance%20polished%20concrete%20floor%20warm%20ambient%20glow%20lighting%20premium%20architecture%20high%20ceiling%20professional%20space%20photography%20atmospheric%20night&width=1920&height=1080&seq=svccta01&orientation=landscape"
      />

      <Footer />
    </main>
  );
}
